import React, { useEffect } from "react";
import axios from "axios";
import apiUrls from "new_components/BaseApi/BaseApi.js";
function VisitorLogger() {
  useEffect(() => {
    axios
      .get(apiUrls.Visitors) // replace with your actual API URL
      .catch((error) => {
        console.error("Error logging visitor data:", error);
      });
  }, []);

  return null; // no UI
}

export default VisitorLogger;
